import type { InfiniteScrollForm } from "./infinite-scroll-form";
import type { InfiniteScrollHandler } from "./infinite-scroll-handler";

export class InfiniteScrollListener {
    public form: InfiniteScrollForm;
    public handler: InfiniteScrollHandler;

    public constructor(form: InfiniteScrollForm, handler: InfiniteScrollHandler) {
        this.form = form;
        this.handler = handler;
    }

    public register(): void {
        this.disconnect();

        const sentinel = this.form.getSentinelElement();
        if (!(sentinel instanceof HTMLElement)) return;
        if (typeof IntersectionObserver === "undefined") return;

        const observer = new IntersectionObserver(
            (entries) => {
                void this.handler.handleIntersect(entries);
            },
            {
                root: null,
                rootMargin: this.form.getRootMargin(),
                threshold: 0,
            },
        );

        observer.observe(sentinel);
        this.form.setObserver(observer);
    }

    public disconnect(): void {
        const observer = this.form.getObserver();
        if (!(observer instanceof IntersectionObserver)) return;

        observer.disconnect();
        this.form.setObserver(null);
    }
}
